<nav class="navbar navbar-expand-lg navbar-themed">
  <div class="container-fluid">

    <!-- Sidebar toggle -->
    <button class="nav-sidebar-toggle" (click)="sidebarToggleClick.emit()" title="Toggle sidebar" aria-label="Toggle sidebar">
      <mat-icon>menu</mat-icon>
    </button>

    <button class="navbar-toggler" type="button" (click)="collapse()" [attr.aria-expanded]="!isCollapsed"
      aria-controls="collapseExample">
      <span class="navbar-toggler-bar navbar-kebab"></span>
      <span class="navbar-toggler-bar navbar-kebab"></span>
      <span class="navbar-toggler-bar navbar-kebab"></span>
    </button>
    <div class="collapse navbar-collapse justify-content-end" id="collapseExample" [ngbCollapse]="isCollapsed">
      <ul class="navbar-nav">
        <li class="nav-item" ngbDropdown>
          <a class="nav-link" id="dropdownBasic1" ngbDropdownToggle>
            <i class="now-ui-icons users_single-02"></i>
            <p>
              <span>{{ accountInfo.name.length > 10 ? (accountInfo.name | slice:0:10) + '...' : accountInfo.name
                }}</span>
            </p>
          </a>
          <div class="dropdown-menu dropdown-menu-right" ngbDropdownMenu aria-labelledby="dropdownBasic1">
            <a *ngIf="accountInfo?.isSuperUser" class="dropdown-item item" href="javascript:void(0);"
              (click)="startTour()">Tour</a>
            <a *ngIf="!accountInfo?.isSuperUser" class="dropdown-item item" href="javascript:void(0);"
              (click)="startTourPersonal()">Tour</a>
            <a class="dropdown-item item" href="/#/settings">Settings</a>
            <a class="dropdown-item item" href="javascript:void(0);" (click)="aboutDialog()">About</a>
            <a class="dropdown-item text-danger" (click)="logout()" href="#">Logout</a>
          </div>
        </li>
      </ul>
    </div>
  </div>
</nav>